export const QA_NAME_RENTAL_PORTAL_SETTINGS_LOAD_RETRY =
  'rentalPortalSettingsLoadRetry'
